import React from "react";
import { Link } from "react-router-dom";
import { PlugZapIcon, BoxIcon } from "lucide-react";
export interface MetricCardProps {
  label: string;
  icon: BoxIcon;
  /** Measured value, or null when no source is connected. */
  value: string | null;
  /** What the number is counting, or what would be counted once connected. */
  detail: string;
  /** Where the measurement comes from, so the number is never unexplained. */
  source: string;
  accent?: boolean;
}
export function MetricCard({
  label,
  icon: Icon,
  value,
  detail,
  source,
  accent = false
}: MetricCardProps) {
  const connected = value !== null;
  return <div className={`rounded-2xl border p-4 ${accent && connected ? 'border-accent/25 bg-accent/[0.06]' : 'border-white/[0.06] bg-ink-850'}`} data-id="element-498" data-mp="1725zca6ozkqa">
      <div className="flex items-center gap-2" data-id="element-499" data-mp="fbrq4r9miwky">
        <Icon className={`h-3.5 w-3.5 ${connected ? 'text-accent-soft' : 'text-zinc-600'}`} strokeWidth={2} data-id="element-500" data-mp="fb04a85twd7v" />
        <span className="text-[12px] leading-tight text-zinc-400" data-id="element-501" data-mp="jbtrt0fczq08">{label}</span>
      </div>

      {connected ? <>
          <div className="mt-2.5 text-[26px] font-semibold leading-none tracking-tight text-white" data-id="element-502" data-mp="11vt7mi4suh4f">{value}</div>
          <div className="mt-1.5 text-[11.5px] text-zinc-500" data-id="element-503" data-mp="wwzuiqtfcs4s">{detail}</div>
          <div className="mt-2.5 border-t border-white/[0.05] pt-2 text-[10.5px] text-zinc-600" data-id="element-504" data-mp="s22ntqjmauv2">{source}</div>
        </> : <>
          <div className="mt-2.5 text-[15px] font-medium leading-none text-zinc-600" data-id="element-505" data-mp="i5r8sssn7qwx">Not connected</div>
          <div className="mt-2 text-[11.5px] leading-relaxed text-zinc-500" data-id="element-506" data-mp="e45q2qtfgiet">{detail}</div>
          <Link to="/studio/settings" className="mt-2.5 inline-flex items-center gap-1.5 border-t border-white/[0.05] pt-2 text-[10.5px] font-medium text-zinc-500 transition-colors hover:text-accent-soft" data-id="element-507" data-mp="e6if1nxlrt1d">
            <PlugZapIcon className="h-3 w-3" data-id="element-508" data-mp="23j2c8b2ugpjt" /> Connect {source}
          </Link>
        </>}
    </div>;
}